import { render, staticRenderFns } from "./NewsTitle.vue?vue&type=template&id=2df843de&"
import script from "./NewsTitle.vue?vue&type=script&lang=js&"
export * from "./NewsTitle.vue?vue&type=script&lang=js&"
import style0 from "./NewsTitle.vue?vue&type=style&index=0&id=2df843de&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports